import { render } from "./FeiernPage.vue?vue&type=template&id=3fa5c365"
import script from "./FeiernPage.vue?vue&type=script&lang=js"
export * from "./FeiernPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__